var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('v-tabs',{attrs:{"align-with-title":""}},[_c('v-tab',{attrs:{"to":"/admin/business/reports/geo/retailers"}},[_vm._v("Retailers")]),_c('v-tab',{attrs:{"to":"/admin/business/reports/geo/artists"}},[_vm._v("Artists")])],1),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }